import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const minutesLabel = (minutes = 0) => `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;

export const currentMonth = () => new Date().toISOString().slice(0, 7);

export const today = () => new Date().toISOString().slice(0, 10);
